var styleDataHash = "3a5d1fb3";
const injectCss = () => {
  var css = `.HosJj{box-sizing:border-box;display:flex;flex-direction:column;width:162px;z-index:10}[dir] .HosJj{background-color:#fff}.HosJj *,.HosJj :after,.HosJj :before{box-sizing:inherit}.HosJj input{box-sizing:border-box}@supports not (contain:inline-size){@media only screen and (max-width:640px){.HosJj{width:100%}}}@container (width < 640px){.HosJj{width:100%}}.sRwGD{align-items:flex-start;align-items:center;display:flex;flex-direction:column;width:100%}[dir] .sRwGD{padding:8px 0}.sRwGD:focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var DropdownModal_default = {
  "modal": "HosJj",
  "dropdownModalOptionsWrapper": "sRwGD"
};
export {
  DropdownModal_default as default,
  injectCss
};
//# sourceMappingURL=DropdownModal-scss.js.map
